<template>
  <Transition name="fade">
    <aside
      v-if="tooltip"
      :class="[
        'text-base fixed 2xl:absolute bottom-0 2xl:bottom-auto left-0 2xl:left-auto w-full p-5 pb-12.5 2xl:p-4 bg-white flex items-start gap-4 drop-shadow-[0_-2px_20px_rgba(0,0,0,0.29)] 2xl:drop-shadow-[0_2px_20px_rgba(0,0,0,0.29)] 2xl:w-75 2xl:rounded-sm transition-all 2xl:-translate-y-4',
        {
          '2xl:-translate-x-80': !tooltip.right,
          '2xl:translate-x-5': tooltip.right,
          '2xl:translate-y-0!': tooltip.id.startsWith('phases'),
        },
      ]"
      :style="
        !mobile
          ? {
              left: tooltip.position.x + 'px',
              top: tooltip.position.y + 'px',
            }
          : undefined
      "
    >
      <span
        class="pointer-events-none [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-2"
        v-html="t(`${tooltip.id}.description`)"
      />
      <span
        :class="[
          'w-0 h-0 border-transparent border-t-5 border-b-5 border-l-white border-l-5 absolute top-5 ',
          {
            'translate-x-full right-0': !tooltip.right,
            'rotate-180 left-0 -translate-x-full': tooltip.right,
          },
        ]"
      ></span>
      <button
        @click.stop="emit('close')"
        class="cursor-pointer ml-auto"
        ref="closeButton"
      >
        <IconSprite id="close" role="presentation" />
      </button>
    </aside>
  </Transition>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import IconSprite from '@/components/small/IconSprite.vue'
import { nextTick, onMounted, onUnmounted, ref, watch } from 'vue'

const { t } = useI18n()

const { tooltip } = defineProps<{
  tooltip: ToolTip | null
}>()

const emit = defineEmits(['close'])

const mobile = ref(false)
const closeButton = ref<HTMLButtonElement | undefined>(undefined)

const updateIsMobile = () => {
  mobile.value = window.innerWidth < 1440
}

watch(
  () => tooltip,
  async (newTooltip, oldTooltip) => {
    await nextTick()
    if (closeButton.value && newTooltip?.locked) {
      closeButton.value.focus()
    } else if (oldTooltip?.target) {
      document.getElementById(oldTooltip?.target ?? '')?.focus()
    }
  }
)

onMounted(() => {
  updateIsMobile()
  window.addEventListener('resize', updateIsMobile)
})

onUnmounted(() => {
  console.log(tooltip)
  window.removeEventListener('resize', updateIsMobile)
})
</script>
